var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThrasblack(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5259_31824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.03062 4.70385L6.84068 9.64231M4.21317 9.64231L4.02323 4.70385M9.49286 2.94277C9.68051 2.97111 9.86752 3.00143 10.0538 3.03371M9.49286 2.94277L8.90692 10.5601C8.85744 11.2033 8.32107 11.7 7.67594 11.7H3.37791C2.73278 11.7 2.19641 11.2033 2.14693 10.5601L1.56098 2.94277M9.49286 2.94277C8.8638 2.84777 8.22744 2.77502 7.58462 2.72535M1 3.03371C1.18633 3.00143 1.37333 2.97111 1.56098 2.94277M1.56098 2.94277C2.19005 2.84777 2.8264 2.77502 3.46923 2.72535M7.58462 2.72535V2.22265C7.58462 1.57551 7.08492 1.03524 6.43812 1.01455C6.13557 1.00488 5.83182 1 5.52692 1C5.22203 1 4.91827 1.00488 4.61573 1.01455C3.96892 1.03524 3.46923 1.57551 3.46923 2.22265V2.72535M7.58462 2.72535C6.90561 2.67288 6.21939 2.64615 5.52692 2.64615C4.83446 2.64615 4.14824 2.67288 3.46923 2.72535",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5259_31824",
    x: 0.5,
    y: 0.5,
    width: 10.054,
    height: 15.7002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5259_31824"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrasblack);
export default __webpack_public_path__ + "static/media/thrasblack.87a6019367e2f7496af76f5eec1df7d5.svg";
export { ForwardRef as ReactComponent };